import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DirectLineTokenResponse } from '../../models/DirectLineTokenResponse';

@Injectable({
    providedIn: 'root'
})
export class CopilotService {

    constructor(private http: HttpClient) {}

    getToken(): Observable<DirectLineTokenResponse> {
        return this.http.post<DirectLineTokenResponse>('/api/copilot/gettoken', {});
    }
}
